import { Accordion, Button, ButtonsGroup, Card, Grid, Link } from "#/atoms";
import { FC, memo } from "react";
import { DESKTOP_SPACING } from "@/theme";

import { GenericServiceProps } from "./OrderService.interface";
import { HeadingIcon } from "#/molecules";

const GenericCustomerService: FC<GenericServiceProps> = ({
  amount,
  externalUrl,
  label,
  name,
}) => {
  const accordionState = 'open';

  return (
    <Card>
        <Accordion
          header={<HeadingIcon icon="services" mb={`${DESKTOP_SPACING.XXL}px`} title={`${name} ${amount ? " X" + amount : ""}`} />}
          showArrow
          state={accordionState}
        >
          <Grid columnGap={DESKTOP_SPACING.XL} gridTemplateColumns="repeat(2, 40%)" margin="0">
           { externalUrl &&  <Link
            href={externalUrl}
            underline={true}
            >
                {label}
            </Link> }
          </Grid>
          <ButtonsGroup>
            <Button>Edit Request</Button>
          </ButtonsGroup>
        </Accordion>
    </Card>
  );
}

export default memo(GenericCustomerService);